import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import { IApiConfigurationResponse } from 'src/app/api/interfaces/configuration.interface';
import {
  setInitialConfigurationsData,
  updateConfigurationData,
} from './configurationState.actions';

export interface IConfigurationsActions {
  type:
    | ' [API] set initial configurations data Success'
    | ' [API] update configurations data Success'
    | string;
}

export const initialState: IApiConfigurationResponse = {
  characterSkillConfigurations: [],
  characterSkillSlotConfigurations: [],
  characterSlotConfigurations: [],
  characterTraitConfigurations: [],
  resourceRecipeConfigurations: [],
  characterConfigurations: [],
  characterSpecialityConfigurations: [],
  landConfigurations: [],
  energyRecipeConfigurations: [],
  storePackConfigurations: [],
  lotteryPackConfigurations: [],
  systemConfiguration: {
    id: '',
    taxRate: 0,
  },
  blockchainConfigurations: [],
};

const _ConfigurationsReducer = createReducer(
  initialState,
  on(setInitialConfigurationsData, (state, { responseData }) => {
    return { ...state, ...responseData };
  }),
  on(updateConfigurationData, (state, { responseData }) => {
    return { ...state, ...responseData };
  })
);

export function ConfigurationsReducer(
  state: IApiConfigurationResponse | undefined,
  action: IConfigurationsActions
) {
  return _ConfigurationsReducer(state, action);
}

export const selectConfigurationsState = createSelector(
  createFeatureSelector<IApiConfigurationResponse>('configurationState'),
  (state) => state
);
